import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { RoleHome } from './RoleHome';

/**
 * Catch-all (`path="*"`) target. Preserves the existing behaviour — an unknown
 * route falls back to the role's home — but first logs a LOW-LEVEL Sentry
 * message so broken internal links / removed pages are visible. It's `info`
 * level (not an error), so it won't trip error-scoped alerts / push notes; the
 * message text is constant (the actual path goes in `extra`) so every hit
 * groups into a single Sentry issue instead of one-per-URL.
 */
export function UnmatchedRoute() {
  const location = useLocation();

  useEffect(() => {
    Sentry.captureMessage('Unmatched route (possible broken link / 404)', {
      level: 'info',
      extra: { path: location.pathname + location.search },
    });
  }, [location.pathname, location.search]);

  return <RoleHome />;
}
